var React = require('react');

function AppointmentLocationIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 11.9238C10.6569 11.9238 12 10.5807 12 8.92383C12 7.26697 10.6569 5.92383 9 5.92383C7.34315 5.92383 6 7.26697 6 8.92383C6 10.5807 7.34315 11.9238 9 11.9238Z","stroke":"#717D77","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 21.4238C11 17.4238 17 14.8421 17 9.42383C17 5.00555 13.4183 1.42383 9 1.42383C4.58172 1.42383 1 5.00555 1 9.42383C1 14.8421 7 17.4238 9 21.4238Z","stroke":"#717D77","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

AppointmentLocationIcon.defaultProps = {"width":"18","height":"23","viewBox":"0 0 18 23","fill":"none"};

module.exports = AppointmentLocationIcon;

AppointmentLocationIcon.default = AppointmentLocationIcon;
